import React from 'react';
import LabelChips from '@/components/common/LabelChips';
import usePreselectedLabels from '@/lib/hooks/swr/usePreselectedLabels';
import type SearchConstituent from '@/types/api/SearchConstituent';
import ColumnMaxMinWidthClasses from '../constants/ColumnMaxMinWidthClasses';

const labelsColumn = {
  columnKey: 'labels',
  headerName: 'CONSTITUENT_LABELS',
  TableCellProps: {
    className: ColumnMaxMinWidthClasses,
  },
  render: (constituent: SearchConstituent) => {
    const { data: labels = [] } = usePreselectedLabels(
      constituent?.labelIds?.tags,
    );

    return <LabelChips labels={labels} size="small" />;
  },
};

export default labelsColumn;
